import React from "react";
import { Card, Typography, Space } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;

const HomePageDummy = () => {
  return (
    <div style={{ padding: "2rem", maxWidth: "800px", margin: "0 auto" }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: "100%" }}>
          <div style={{ textAlign: "center" }}>
            <LockOutlined style={{ fontSize: "48px", color: "#1890ff" }} />
            <Title level={2}>Admin Access Required</Title>
          </div>

          <Text className="text-center">
            This area requires administrative privileges. Please contact your
            system administrator to obtain the login URL and access credentials.
            For security reasons, admin access is restricted and requires proper
            authorization. Login using
            {/* todo: remove this before committing */}
            <Link to="/taas-login/">this link</Link>.
          </Text>
        </Space>
      </Card>
    </div>
  );
};

export default HomePageDummy;
